<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" md="8" class="pa-0">
        <!-- {{ activeTab }} -->
        <v-tabs
          v-model="activeTab"
          show-arrows
          color="#519043"
          align-tabs="left"
        >
          <v-tab
            :disabled="loading"
            :active-class="activeTab.name"
            v-for="tab in tabList"
            :key="tab.id"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        md="4"
        class="d-flex justify-space-between"
        style="column-gap: 5px"
      >
        <v-text-field
          v-if="tab != 5"
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#519043"
          dense
        ></v-text-field>
        <v-text-field
          v-if="tab == 5"
          v-model="searchKey"
          @keyup="searchTable()"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#519043"
          dense
        ></v-text-field>
        <v-btn
          icon
          v-if="tab == 5 && !showSideBtn"
          large
          @click="showSideBtn = !showSideBtn"
          ><v-icon
            >{{ showSideBtn ? "mdi-arrow-right" : "mdi-arrow-left" }}
          </v-icon></v-btn
        >
        <v-expand-x-transition>
          <div class="d-flex" v-if="showSideBtn">
            <v-btn
              v-if="tab == 5"
              :color="$vuetify.theme.themes.light.submitBtns"
              @click="
                addCreditsDialog = true;
                showSideBtn = !showSideBtn;
              "
              class="white--text mr-1"
              >Add credits</v-btn
            >
            <v-btn
              v-if="tab == 5"
              @click="
                deduct_FL();
                showSideBtn = !showSideBtn;
              "
              color="warning"
              class="white--text"
              >Deduct FL</v-btn
            >
          </div>
        </v-expand-x-transition>
      </v-col>
    </v-row>

    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="
          tab == 6
            ? force_leave_headers
            : tab != 5
            ? headers
            : leave_credit_headers
        "
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:top v-if="tab == 6">
          <v-tabs
            v-model="activeTab1"
            show-arrows
            color="#519043"
            align-tabs="left"
            class="mb-2"
          >
            <v-tab
              :disabled="loading"
              :active-class="activeTab1.name"
              v-for="tab in tabList1"
              :key="tab.id"
              @click="changeTab1(tab)"
              >{{ tab.name }}</v-tab
            >
          </v-tabs>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.dates_filed`]="{ item }">
          <v-hover
            v-slot="{ hover }"
            v-for="dates in item.dates_filed"
            :key="dates.id"
          >
            <v-chip
              class="mx-1 chip-block my-1"
              x-small
              :color="
                hover
                  ? 'blue'
                  : dates.isFiled == 1
                  ? 'green'
                  : !currentDate(dates)
                  ? 'red'
                  : 'gray'
              "
            >
              <!-- @click="sample(dates.id)" -->
              <span
                :class="
                  hover
                    ? 'white--text'
                    : !currentDate(dates)
                    ? 'white--text'
                    : dates.isFiled == 0
                    ? 'black--text'
                    : 'white--text'
                "
              >
                {{ formatDate(dates.date) }}
              </span>
            </v-chip>
          </v-hover>
        </template>
        <template v-slot:[`item.submittedDate`]="{ item }">
          {{ formatDate(item.submittedDate) }}
        </template>
        <template v-slot:[`item.head_user_approve_date`]="{ item }">
          <u>{{ item.head_name }}</u>
          <br />
          {{ formatDate(item.head_user_approve_date) }}
        </template>
        <template v-slot:[`item.president_approve_date`]="{ item }">
          {{ formatDate(item.president_approve_date) }}
        </template>
        <template v-slot:[`item.applicant_name`]="{ item }">
          {{ item.applicant_name }}
        </template>
        <template v-slot:[`item.tl_desc`]="{ item }">
          {{
            item.type_of_leave_ID == 14 && item.selected_details_of_leave == 1
              ? item.tl_desc + " / " + "Monetization"
              : item.type_of_leave_ID == 14 &&
                item.selected_details_of_leave == 2
              ? item.tl_desc + " / " + "Terminal Leave"
              : item.type_of_leave_ID == 14 &&
                item.selected_details_of_leave == 3
              ? item.tl_desc + " / " + "CTO"
              : item.tl_desc
          }}
        </template>

        <template v-if="tab != 5" v-slot:[`item.created_at`]="{ item }">
          {{
            item.date_filed
              ? formatDate(item.date_filed)
              : formatDate(item.created_at)
          }}
        </template>

        <template v-if="!loading" v-slot:[`item.actions`]="{ item }">
          <v-btn
            v-if="tab != 6"
            elevation="2"
            color="#17C800"
            class="white--text mx-1"
            :block="$vuetify.breakpoint.smAndDown"
            x-small
            @click="
              viewItem(
                tab == 1
                  ? 'Certify'
                  : tab == 2
                  ? 'Certified'
                  : tab == 3
                  ? 'Approved'
                  : '',
                item,
              )
            "
          >
            <v-icon size="14">mdi-eye</v-icon>
            view {{ tab == 5 ? "Leave Card" : "" }}</v-btn
          >
          <v-btn
            v-if="tab == 5"
            elevation="2"
            color="warning"
            class="white--text mx-1"
            :block="$vuetify.breakpoint.smAndDown"
            x-small
            @click="viewCTOCard(item)"
          >
            <v-icon size="14">mdi-eye</v-icon>
            view CTO card</v-btn
          >
        <v-btn
            v-if="tab == 5"
            elevation="2"
            color="red"
            class="white--text mx-1"
            x-small
            :block="$vuetify.breakpoint.smAndDown"
            @click="view_disapprove_leave(item)"
          >
            <v-icon size="14">mdi-eye</v-icon>
            View Disapproved</v-btn
          > 
          <v-btn
            v-if="tab == 6"
            elevation="2"
            color="green"
            class="white--text mx-1"
            :loading="loading"
            :block="$vuetify.breakpoint.smAndDown"
            x-small
            @click="recieve(item)"
          >
            <v-icon size="14">mdi-file-arrow-left-right-outline</v-icon>
            Recieve</v-btn
          >
          <!-- <v-btn
            class="mx-1"
            color="#17C800"
            outlined
            x-small
            @click="printItem(item)"
          >
            <v-icon size="14">mdi-printer</v-icon>
            print</v-btn
          > -->
        </template>

        <template v-if="tab == 5" v-slot:[`item.VL_TOTAL`]="{ item }">
          {{
            loading
              ? ""
              : !item.VL_TOTAL
              ? 0
              : formatNumberValue(item.VL_TOTAL, 3)
          }}
        </template>

        <template v-if="tab == 5" v-slot:[`item.SL_TOTAL`]="{ item }">
          {{
            loading
              ? ""
              : !item.SL_TOTAL
              ? 0
              : formatNumberValue(item.SL_TOTAL, 3)
          }}
        </template>

        <template v-if="tab == 5" v-slot:[`item.CURRENT_SPL_TOTAL`]="{ item }">
          {{ item.CURRENT_SPL_TOTAL }}
        </template>

        <template v-if="tab == 5" v-slot:[`item.CURRENT_CTO`]="{ item }">
          {{
            item.CURRENT_CTO != null && item.CURRENT_CTO != ""
              ? take2Decimal(item.CURRENT_CTO)
              : 0
          }}
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            color="#519043"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>
      <v-col
        v-if="tab != 5"
        cols="auto"
        class="mr-auto text-truncate"
        no-gutters
      >
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col v-if="tab != 5" cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
      <v-col
        v-if="tab == 5"
        cols="auto"
        class="mr-auto text-truncate"
        no-gutters
      >
        Showing {{ paginationData1.pageStart + 1 }} to
        {{ paginationData1.pageStop }} of
        {{ paginationData1.itemsLength }} entries
      </v-col>
      <v-col v-if="tab == 5" cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData1.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <!-- <AddLeaveCreditsDialog :data="viewData" :action="action" /> -->
    <AddVLSLDialog :data="viewData" />
    <AddSPLDialog :data="viewSplData" />
    <AddWellnessScheduleDialog :data="viewWellnessSchedule" />
    <AddCTODialog :data="viewCtoData" />
    <DisapprovedLeaveApplicantion :data="viewDisapproveData" />

    <AddSSCDialog :data="viewSSC" />
    <AddLeaveWorkbackDialog :data="viewWorkback" />
    <AddBalanceForwardedDialog :data="viewBalanceForwared" />
    <DeductForceLeaveDialog :data="viewFL" />
    <ConvertVLToSLDialog :data="viewConvertVLToSL" />

    <ViewApplicationForLeaveDialog
      :data="viewApplicationData"
      :action="action"
      :tab="tab"
    />

    <ViewApprovedLeaveDialog :data="viewApprovedData" />
    <ViewEmployeeLeaveCardDialog :data="viewLeaveCardData" />
    <ViewCTOCardDialog :data="viewCTO" />

    <v-dialog v-model="confirmDialog" persistent max-width="290">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-overline mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to {{ confirmAction }} this locator slip?
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addCreditsDialog" persistent max-width="800" scrollable>
      <v-card color="white">
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Select Action</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="addCreditsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            class="d-flex justify-space-evenly pa-4 #3a3b3a--text box_wrapper"
          >
            <div @click="add_vlsl()" class="box ma-2">VL/SL</div>
            <!-- <div class="box ma-2">CTO</div> -->
            <div @click="add_cto()" class="box ma-2">CTO</div>
            <div @click="add_servCredit()" class="box ma-2">
              Special Service Credit
            </div>
            <div @click="add_prevCredit()" class="box ma-2">
              Balance Forwarded
            </div>
            <div @click="convertVLToSL()" class="box ma-2 text-center">
              VL to SL<br />
              Conversion
            </div>
            <!-- <div class="box ma-2"> -->
            <div @click="addWorkBack()" class="box ma-2">Leave Workback</div>
            <div @click="addWellnessSchedule()" class="box ma-2">
              Wellness Schedule
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    // AddLeaveCreditsDialog: () =>
    //   import("../../components/Dialogs/Forms/AddLeaveCreditsDialog.vue"),
    AddVLSLDialog: () =>
      import("../../components/Dialogs/Forms/AddVLSLDialog.vue"),
    AddSSCDialog: () =>
      import("../../components/Dialogs/Forms/AddSSCDialog.vue"),
    AddCTODialog: () =>
      import("../../components/Dialogs/Forms/AddCTODialog.vue"),

    DisapprovedLeaveApplicantion: () =>
      import("../../components/Dialogs/Forms/DisapprovedLeaveApplicantion.vue"),
    AddSPLDialog: () =>
      import("../../components/Dialogs/Forms/AddSPLDialog.vue"),
    AddBalanceForwardedDialog: () =>
      import("../../components/Dialogs/Forms/AddBalanceForwardedDialog.vue"),
    AddLeaveWorkbackDialog: () =>
      import("../../components/Dialogs/Forms/AddLeaveWorkbackDialog.vue"),
    ConvertVLToSLDialog: () =>
      import("../../components/Dialogs/Forms/ConvertVLToSLDialog.vue"),
    DeductForceLeaveDialog: () =>
      import("../../components/Dialogs/Forms/DeductForceLeaveDialog.vue"),
    ViewApplicationForLeaveDialog: () =>
      import(
        "../../components/Dialogs/Views/ViewApplicationForLeaveDialog.vue"
      ),
    ViewApprovedLeaveDialog: () =>
      import("../../components/Dialogs/Views/ViewApprovedLeaveDialog.vue"),
    ViewEmployeeLeaveCardDialog: () =>
      import("../../components/Dialogs/Views/ViewEmployeeLeaveCardDialog.vue"),
    ViewCTOCardDialog: () =>
      import("../../components/Dialogs/Views/ViewCTOCardDialog.vue"),
    AddWellnessScheduleDialog: () =>
      import("../../components/Dialogs/Forms/AddWellnessScheduleDialog.vue"),
  },
  data: () => ({
    showSideBtn: false,
    search: "",
    addCreditsDialog: false,
    viewDisapproveData: null,
    headers: [
      {
        text: "Name",
        value: "applicant_name",
        align: "start",
        valign: "center",
      },
      {
        text: "Position",
        value: "position",
        align: "center",
        valign: "center",
      },
      {
        text: "Office",
        value: "office",
        align: "center",
        valign: "center",
      },
      {
        text: "Date Filed",
        value: "created_at",
        align: "center",
        valign: "center",
      },
      {
        text: "Type of Leave",
        value: "tl_desc",
        align: "center",
        valign: "center",
      },

      {
        text: "Actions",
        value: "actions",
        align: "center",
        valign: "center",
        sortable: false,
      },
    ],
    leave_credit_headers: [
      { text: "Name", value: "name", align: "start", valign: "center" },
      {
        text: "Vacation Leave",
        value: "VL_TOTAL",
        align: "center",
        valign: "center",
      },
      {
        text: "Sick Leave",
        value: "SL_TOTAL",
        align: "center",
        valign: "center",
      },
      {
        text: "SPL",
        value: "CURRENT_SPL_TOTAL",
        align: "center",
        valign: "center",
      },
      {
        text: "CTO",
        value: "CURRENT_CTO",
        align: "center",
        valign: "center",
      },

      {
        text: "WL",
        value: "CURRENT_WL",
        align: "center",
        valign: "center",
      },

      {
        text: "Actions",
        value: "actions",
        align: "center",
        valign: "center",
        sortable: false,
      },
    ],
    force_leave_headers: [
      { text: "Name", value: "name", align: "start" },

      {
        text: "Dates Filed",
        value: "dates_filed",
        align: "center",
      },

      {
        text: "Date Submitted",
        value: "submittedDate",
        align: "center",
      },
      {
        text: "Head Approved",
        value: "head_user_approve_date",
        align: "center",
      },

      {
        text: "President Approved",
        value: "president_approve_date",
        align: "center",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        valign: "center",
        sortable: false,
      },
    ],
    all_force_leave_headers: [
      { text: "Name", value: "name", align: "start", showOnlyTab1: false },
      {
        text: "Dates Filed",
        value: "dates_filed",
        align: "center",
        showOnlyTab1: false,
      },
      {
        text: "Date Submitted",
        value: "submittedDate",
        align: "center",
        showOnlyTab1: false,
      },
      {
        text: "Head Approved",
        value: "head_user_approve_date",
        align: "center",
        showOnlyTab1: false,
      },
      {
        text: "President Approved",
        value: "president_approve_date",
        align: "center",
        showOnlyTab1: false,
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        showOnlyTab1: true,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    // activeTab: { id: 1, name: "For Certification" },
    activeTab: 0,
    tab: 1,
    tabList: [
      { id: 1, name: "For Certification" },
      { id: 2, name: "Certified" },
      { id: 3, name: "Pending" },
      { id: 4, name: "Approved Leave" },
      { id: 5, name: "Leave Credits" },
      // { id: 6, name: "FL Schedule" },
    ],
    activeTab1: 0,
    tab1: 1,
    tabList1: [
      { id: 1, name: "For Recieve" },
      { id: 2, name: "Recieved" },
    ],
    totalCount: 0,
    confirmDialog: false,
    confirmAction: null,
    confirmApprovalID: null,
    viewApprovedData: null,
    viewData: null,
    viewSplData: null,
    viewWellnessSchedule: null,
    viewCtoData: null,
    viewSSC: null,
    viewFL: null,
    viewBalanceForwared: null,
    viewApplicationData: null,
    viewLeaveCardData: null,
    viewConvertVLToSL: null,
    viewWorkback: null,
    viewCTO: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    paginationData1: {},
    searchKey: null,
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),

  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
  },
  watch: {
    options: {
      handler() {
        this.initialize();
        // this.initialize(this.tab);
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeAddLeaveCreditsDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeDisapprovedApplicationDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeAddVLSLDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeAddSPLDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeCTODialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeSSCDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeDeductFLDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeLeaveWorkbackDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeBalanceForwardedDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeConvertVLToSLDialog", () => {
      this.initialize();
    });

    this.eventHub.$on("closeViewApplicationForLeaveDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewEmployeeLeaveCardDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewApprovedLeaveDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewCTOCardDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeWellnessDialog", () => {
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeAddLeaveCreditsDialog");
    this.eventHub.$off("closeViewApplicationForLeaveDialog");
    this.eventHub.$off("closeAddVLSLDialog");
    this.eventHub.$off("closeAddSPLDialog");
    this.eventHub.$off("closeCTODialog");
    this.eventHub.$off("closeSSCDialog");
    this.eventHub.$off("closeLeaveWorkbackDialog");
    this.eventHub.$off("closeDisapprovedApplicationDialog");

    this.eventHub.$off("closeDeductFLDialog");
    this.eventHub.$off("closeWellnessDialog");
    this.eventHub.$off("closeConvertVLToSLDialog");
    this.eventHub.$off("closeViewEmployeeLeaveCardDialog");
    this.eventHub.$off("closeViewApprovedLeaveDialog");
    this.eventHub.$off("closeViewCTOCardDialog");
  },

  methods: {
    formatTextCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    pagination(data) {
      this.paginationData = data;
    },
    currentDate(data) {
      if (!data?.date) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0); // normalize

      const itemDate = new Date(data.date);
      itemDate.setHours(0, 0, 0, 0);
      return itemDate >= today;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
      // this.initialize(tab.id);
    },

    changeTab1(tab) {
      this.activeTab1 = tab;
      this.tab1 = tab.id;

      this.force_leave_headers =
        this.tab1 === 1
          ? this.all_force_leave_headers
          : this.all_force_leave_headers.filter((h) => h.showOnlyTab1 !== true);

      this.initialize();
    },

    initialize() {
      let filter = this.$store.getters.getFilterSelected;
      this.loading = true;
      if (this.tab == 1 || this.tab == 2 || this.tab == 3) {
        this.axiosCall(
          "/leaves/getLeaveApplications/" + this.tab + "/" + filter,
          "GET",
        ).then((res) => {
          if (res) {
            let data = res.data;
            // console.log(res.data);
            data.forEach((element, i) => {
              data[i].applicant_name = this.toTitleCase(element.applicant_name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      } else if (this.tab == 4) {
        this.axiosCall("/leaves/getApprovedLeaves/" + filter, "GET").then(
          (res) => {
            if (res) {
              let data = res.data;
              data.forEach((element, i) => {
                data[i].applicant_name = this.toTitleCase(
                  element.applicant_name,
                );
              });
              this.data = data;
              this.loading = false;
            }
          },
        );
      } else if (this.tab == 5) {
        // this.axiosCall("/employee-accum-leaves/" + filter, "GET")
        if (this.searchKey && this.searchKey != "") {
          let keys = "";
          setTimeout(() => {
            keys = this.searchKey;

            this.axiosCall(
              "/employee-accum-leaves/" +
                filter +
                "/?page=" +
                this.options.page +
                "&itemPerPage=" +
                this.options.itemsPerPage +
                "&searchKey=" +
                keys,
              "GET",
            ).then((res) => {
              if (res) {
                this.paginationData1 = {
                  page: this.options.page,
                  pageStart:
                    (res.data.pagination.currentPage - 1) *
                    this.options.itemsPerPage,
                  pageStop: res.data.pagination.pageStop,
                  pageCount: res.data.pagination.pageCount,
                  itemsPerPage: this.options.itemsPerPage,
                  itemsLength: res.data.pagination.count,
                };

                let data = res.data.data;
                data.forEach((element, i) => {
                  data[i].name = this.toTitleCase(element.name);
                });
                this.data = data;

                this.loading = false;
              }
            });
          }, 2000);
        } else {
          this.axiosCall(
            "/employee-accum-leaves/" +
              filter +
              "/?page=" +
              this.options.page +
              "&itemPerPage=" +
              this.options.itemsPerPage,
            "GET",
          ).then((res) => {
            if (res) {
              this.paginationData1 = {
                page: this.options.page,
                pageStart:
                  (res.data.pagination.currentPage - 1) *
                  this.options.itemsPerPage,
                pageStop: res.data.pagination.pageStop,
                pageCount: res.data.pagination.pageCount,
                itemsPerPage: this.options.itemsPerPage,
                itemsLength: res.data.pagination.count,
              };

              let data = res.data.data;
              data.forEach((element, i) => {
                data[i].name = this.toTitleCase(element.name);
              });
              this.data = data;

              this.loading = false;
            }
          });
        }
      } else if (this.tab == 6) {
        this.axiosCall(
          "/leaves/forceLeavePlottingHR/" + filter + "/" + this.tab1,
          "GET",
        ).then((res) => {
          console.log(res.data);
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      }
    },

    searchTable() {
      this.initialize();
    },

    add_vlsl() {
      this.viewData = { id: null };
      this.addCreditsDialog = false;
    },
    add_servCredit() {
      this.viewSSC = { id: null };
      this.addCreditsDialog = false;
    },
    add_cto() {
      this.viewCtoData = { id: null };
      this.addCreditsDialog = false;
    },
    view_disapprove_leave(item) {
      this.viewDisapproveData = item;
    },

    add_spl() {
      this.viewSplData = { id: null };
      this.addCreditsDialog = false;
    },

    add_prevCredit() {
      this.viewBalanceForwared = { id: null };
      this.addCreditsDialog = false;
    },

    convertVLToSL() {
      this.viewConvertVLToSL = { id: null };
      this.addCreditsDialog = false;
    },

    addWorkBack() {
      this.viewWorkback = { id: null };
      this.addCreditsDialog = false;
    },

    addWellnessSchedule() {
    this.viewWellnessSchedule = { id: null };
    this.addCreditsDialog = false;
    },

    deduct_FL() {
      this.viewFL = { id: null };
    },

    apply() {
      this.viewData = { id: null };
      this.action = "Apply";
    },

    viewItem(action, item) {
      if (this.tab == 4) {
        this.viewApprovedData = item;
      } else if (this.tab == 5) {
        this.viewLeaveCardData = item;
      } else {
        this.viewApplicationData = item;
        this.action = action;
      }
    },

    viewCTOCard(item) {
      this.viewCTO = item;
    },

    viewLeaveCredit(item) {
      console.log(item);
    },

    printItem(item) {
      const url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/print-employee-assessment/" +
        item.EA_id;
      window.open(url);
    },

    approve() {
      let data = {
        id: this.confirmApprovalID,
        status: 2,
      };
      // console.log(data);
      this.axiosCall("/my-locator-slip/approve-locator", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.confirmDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.initialize(this.tab);
          } else if (res.data.status == 400) {
            this.confirmDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.initialize(this.tab);
          }
        },
      );
    },
    deleteItem(item) {
      this.dialogConfirmDelete = true;
      this.deleteData = item;
    },
    editItem(item) {
      this.updateData = [{ id: null }];
      setTimeout(() => {
        this.updateData = item;
        this.action = "Update";
      }, 100);
    },
    confirm(action, item) {
      // console.log(item);
      this.confirmAction = action;
      this.confirmDialog = true;
      this.confirmApprovalID = item.id;
    },

    recieve(item) {
      this.loading = true;
      this.axiosCall("/leaves/recieveFLPlotting/" + item.id, "PATCH", {}).then(
        (res) => {
          if (res) {
            if (res.data.status == 200) {
              this.initialize();
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.loading = false;
            } else {
              this.loading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        },
      );
    },
  },
};
</script>
<style scoped>
.box_wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.box {
  width: 30%;
  border: 1px solid #c0c0c0;
  height: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 10px;
  font-size: 20px;
}
.box:hover {
  cursor: pointer;
  background-color: #519043;
  color: white;
}
.chip-block {
  display: flex;
  width: 100%;
  justify-content: center;
}
</style>
